module.exports = __webpack_public_path__ + "img/surgery.2fbc52ea.svg";